export const DOCUMENT_TYPE_PROJECT = 'project';
